export enum ROUTES {
  LOGIN = '/login',
  CREATE_ACCOUNT = '/create-account',
  ADMIN_PANEL = '/admin-panel',
  CREATE_CLINIC = '/create-clinic',
  REQUEST_DYNAMIC_LINK = '/request-dynamic-link',
  DYNAMIC_LINK_SENT = '/dynamic-link-sent',
}
